import styled from 'styled-components';

export const Container = styled.div`
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

export const NullStatus = styled.div`
    display: flex;
    align-items: center;
    font-size: 2rem;
    padding-left: 1rem;

    &::before {
        content: '';
        width: 1.5rem;
        height: 2px;
        background-color: #888;
    }
`;
